<template>
    <button @click="onClick" class="voteButton">
        <slot v-show="!buffering"></slot>
        <spinner class="voteButton__spinner" v-show="buffering"></spinner>
    </button>
</template>

<script>
import Spinner from './spinner';

export default {
  data() {
    return {
      buffering: false,
    };
  },
  components: {
    Spinner,
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.voteButton {
    position: relative;
    background: transparent;
    color: var(--color-white);
    border: unset;
    background-color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    padding: 5px;
    width: 115px;
    height: 115px;
    border-radius: 50%;

    @media (hover: hover) {
        &:hover:not(:disabled) {
            background: var(--color-white);
            color: var(--color-black);
        }
    }

    &:disabled {
      opacity: 0.2;
      cursor:initial;
      // background: transparent;
      color: var(--color-white);
    }

    &__spinner {
      right: -40px!important;
    }
}
</style>
